export default function validate(values) {
  let errors = {}
  if (!values.deliveryTime) {
    errors.email = 'Delivery time is required'
  }
  return errors
}
